import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import TopNav from "@/components/TopNav";

export default function UpdatePassword() {
  const { updatePassword, session, loading } = useAuth();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!loading && !session) {
      toast.error("Recovery link expired or invalid. Please request a new one.");
      nav("/forgot-password");
    }
  }, [loading, session, nav]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("Password must be at least 8 characters");
    setSaving(true);
    try {
      await updatePassword(password);
      toast.success("Password updated.");
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.message || "Update failed");
    } finally { setSaving(false); }
  };

  return (
    <div className="min-h-screen bg-white">
      <TopNav />
      <div className="max-w-[720px] mx-auto px-5 sm:px-6 py-14">
        <div className="fx-mono-tag mb-4">§ SET NEW PASSWORD</div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight leading-tight">Choose a new password.</h1>
        <form onSubmit={submit} className="mt-8 border border-[#DCE3ED] p-8 lg:p-10 bg-white rounded-xl" data-testid="update-password-form">
          <Label className="fx-mono-tag">NEW PASSWORD</Label>
          <Input required type="password" autoComplete="new-password" value={password} onChange={e=>setPassword(e.target.value)} className="mt-2 h-11 rounded-md" placeholder="8+ characters" data-testid="new-password-input" />
          <Button disabled={saving || !session} className="fx-btn-primary h-11 w-full rounded-lg mt-6 text-sm font-semibold" data-testid="update-password-submit-btn">
            {saving ? "Saving…" : "Update password →"}
          </Button>
        </form>
      </div>
    </div>
  );
}
